import {sendRequest} from '@js/utils';
import Modal from '@js/components/modal';
import initContactForm from '@js/components/feedbackForm';
import Notifier from '@js/components/Notifier';

export default function initReportMistakeButton($selector) {
    $selector
        .on('click', (e) => {
            e.preventDefault();
            sendRequest('get', '/contacts/getReportMistakeModal', {}, (res) => {
                if (res?.success && res?.modalBody) {
                    const modal = new Modal(res.modalBody);
                    const $modal = modal.show();
                    initContactForm($modal);
                } else {
                    (new Notifier()).error(res?.message);
                }
            });
        });
}
